import React, { Component } from 'react';
import { CognitoUserPool, AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js';

const cognitoUserPoolId = process.env.COGNITO_USER_POOL_ID;
const cognitoClientId = process.env.COGNITO_CLIENT_ID;

const CompanyIcon = (
  <svg width="160" height="120" xmlns="http://www.w3.org/2000/svg">
    <g>
      <title>MLLogo</title>
      <path transform="rotate(90.2149 76.6636 60.1476)" stroke="#0070C0" id="svg_3" d="m28.42838,60.14771l20.6,-41.19856l55,0l20.67224,41.19856l-20.67224,41.19856l-55.32776,0l-20.67224,-41.19856z" fill="none"/>
      
      <line id="svg_5" y2="87.6" x2="118" y1="12" x1="76.6" stroke="#0070C0" stroke-width="0.2" fill="none" />
      <line id="svg_6" y2="87.6" x2="118" y1="32.4" x1="36" stroke="#0070C0" stroke-width="0.2" fill="none"/>
      <line id="svg_7" y2="87.6" x2="118" y1="87.6" x1="36" stroke="#0070C0" stroke-width="0.2" fill="none"/>
      
      <line id="svg_8" y2="87.6" x2="36" y1="32.4" x1="36" stroke="#0070C0" stroke-width="3" fill="none" stroke-linecap="round"/>
      <line id="svg_9" y2="87.6" x2="36" y1="32.4" x1="36" stroke="#0070C0" stroke-width="3" fill="none" stroke-linecap="round"/>
      <line id="svg_10" y2="87.6" x2="56.2" y1="32.4" x1="36" stroke="#0070C0" stroke-width="3" fill="none" stroke-linecap="round"/>
      <line id="svg_11" y2="32.4" x2="77" y1="87.6" x1="56.2" stroke="#0070C0" stroke-width="3" fill="none" stroke-linecap="round"/>
      
      <line id="svg_12" y2="87.6" x2="77" y1="32.4" x1="77" stroke="#0070C0" stroke-width="3" fill="none" stroke-linecap="round"/>
      <line id="svg_13" y2="87.6" x2="118" y1="87.6" x1="77" stroke="#0070C0" stroke-width="3" fill="none" stroke-linecap="round"/>
        
      <circle cx="36" cy="87.6" r="3" stroke="#0070C0" fill="#0070C0" />
      <circle cx="118" cy="87.6" r="3" stroke="#0070C0" fill="#0070C0" />
      
    </g>
  </svg>
)

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      newPassword: '',
      resetPasswordRequired: false,
      loginError: '',
      cognitoUser: null,
      submitted: false
    };
    this.userPool = new CognitoUserPool({
      UserPoolId: cognitoUserPoolId,
      ClientId: cognitoClientId
    });
  }

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
      loginError: '' // Clear the login error when input changes
    });
  }

  handleLogin = (event) => {
    event.preventDefault();
    const { username, password } = this.state;
    this.setState({ submitted: true })

    const authenticationData = {
      Username: username,
      Password: password
    };
    const authenticationDetails = new AuthenticationDetails(authenticationData);
    const userData = {
      Username: username,
      Pool: this.userPool
    };
    const cognitoUser = new CognitoUser(userData);

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (session) => {
        const tokens = {
          accessToken: session.getAccessToken().getJwtToken(),
          idToken: session.getIdToken().getJwtToken(),
          refreshToken: session.getRefreshToken().getToken()
        };
        sessionStorage.setItem('token', session.getIdToken().getJwtToken());
        this.props.onLoginSuccess(session);
        this.setState({
          submitted: false
        })
      },
      onFailure: (err) => {
        console.error('Authentication failed:', err);
        this.setState({
          loginError: 'Incorrect username or password.',
          submitted: false
        })
      },
      newPasswordRequired: (userAttributes, requiredAttributes) => {
        this.setState({
          resetPasswordRequired: true,
          cognitoUser: cognitoUser,
          submitted: false
        });
      }
    });

  }

  handlePasswordChange = (event) => {
    event.preventDefault();
    this.setState({ submitted: true })
    const cognitoUser = this.state.cognitoUser;
    const { newPassword } = this.state;
    cognitoUser.completeNewPasswordChallenge(newPassword, {}, {
      onSuccess: (session) => {
        const tokens = {
          accessToken: session.getAccessToken().getJwtToken(),
          idToken: session.getIdToken().getJwtToken(),
          refreshToken: session.getRefreshToken().getToken()
        };
        sessionStorage.setItem('token', session.getIdToken().getJwtToken());
        this.props.onLoginSuccess(session);
        this.setState({
          submitted: false
        })
      },
      onFailure: (err) => {
        console.error('Password change failed:', err);
        this.setState({ 
          loginError: "Error: password must have at least one: lower case character, upper case character, number and symbol.",
          submitted: false
        });
      }
    });

  }

  render() {
    const { loginError, resetPasswordRequired, submitted } = this.state;
    return (
      <div style={{ textAlign: 'center' }}>
        {CompanyIcon}
        <h2>Login</h2>
        {resetPasswordRequired ? (
          <form onSubmit={this.handlePasswordChange} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ marginBottom: '10px' }}>
              <label htmlFor="username">Username:</label>
              <input
                type="text"
                id="username"
                name="username"
                value={this.state.username}
                onChange={this.handleInputChange}
                style={{ marginLeft: '5px' }}
              />
            </div>
            {resetPasswordRequired && (
              <div style={{ marginBottom: '10px' }}>
                <label htmlFor="newPassword">New Password:</label>
                <input
                  type="password"
                  id="newPassword"
                  name="newPassword"
                  value={this.state.newPassword}
                  onChange={this.handleInputChange}
                  style={{ marginLeft: '5px' }}
                />
              </div>
            )}
            <button disabled={submitted} type="submit" style={{ marginTop: '10px' }}>Login</button>
            {loginError && <p style={{ color: 'red' }}>{loginError}</p>}
          </form>
        ) : (
          <form onSubmit={this.handleLogin} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ marginBottom: '10px' }}>
              <label htmlFor="username">Username:</label>
              <input
                type="text"
                id="username"
                name="username"
                value={this.state.username}
                onChange={this.handleInputChange}
                style={{ marginLeft: '5px' }}
              />
            </div>
            <div style={{ marginBottom: '10px' }}>
              <label htmlFor="password">Password:</label>
              <input
                type="password"
                id="password"
                name="password"
                value={this.state.password}
                onChange={this.handleInputChange}
                style={{ marginLeft: '5px' }}
              />
            </div>
            <button disabled={submitted} type="submit" style={{ marginTop: '10px' }}>Login</button>
            {loginError && <p style={{ color: 'red' }}>{loginError}</p>}
          </form>
        )}
        
      </div>
    );
  }
}

export default Login;
